import { render, staticRenderFns } from "./batchCreateAssistant.vue?vue&type=template&id=002a8fb4&scoped=true&"
import script from "./batchCreateAssistant.vue?vue&type=script&lang=js&"
export * from "./batchCreateAssistant.vue?vue&type=script&lang=js&"
import style0 from "./batchCreateAssistant.vue?vue&type=style&index=0&id=002a8fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a8fb4",
  null
  
)

export default component.exports